module.exports = {
  name: '人員資料',
  model: 'users',
  middlewares: [
    next => (ctx) => {
      const { method } = ctx
      if (method === 'GET') return next(ctx)

      const { values } = ctx
      if (!values.password) delete values.password

      return next(ctx)
    }
  ],
  ui: {
    list: {
      columns: [
        { key: 'account' },
        { key: 'name' },
      ],
    },
    editor: {
      groups: [
        {
          name: '',
          rows: [
            [{ key: 'account' }],
            [{ key: 'name' }],
          ],
        },
      ],
    },
  },
}



// WEBPACK FOOTER //
// ./src/views/staffers.js